<div class="contents-area box1">
  <div>
    <div class="search-button">
      <button id="btn_Seach" class="btn-secondary" #btn_Seach forcedEnabledMode="true"
        (click)="eventSeach_CLICKHandler()" [tabindex]="0">商品検索</button>
    </div>
  </div>

  <div style="width: 1622px;">
    <div class="action-area">
      <div class="guide-label">
        <label class="other-pcode">通常のデータ(編集可)</label>
        <label class="use-otheruser-pcode">他のユーザーが編集中のデータ</label>
        <label class="specified-handling-period-pcode">取扱終了日指定ありのデータ</label>
      </div>
      <button id="btn_AllSelect" class="btn-tartiary" #btn_AllSelect [disabled]="!kymw4200Model.btnAllSelectEnabled"
        forcedEnabledMode="true" (click)='eventAllSelect_CLICKHandler()' [tabindex]="0">全選択</button>
      <button id="btn_AllUnSelect" class="btn-tartiary" #btn_AllUnSelect [disabled]="!kymw4200Model.btnAllUnSelectEnabled"
        forcedEnabledMode="true" (click)='eventAllUnSelect_CLICKHandler()' [tabindex]="0">全解除</button>
      <app-pager [prevDisabled]="!kymw4200Model.btnBackEnabled" [nextDisabled]="!kymw4200Model.btnNextEnabled"
        [totalNum]="kymw4200Model.totalNum" [startNum]="kymw4200Model.startDispNum" [endNum]="kymw4200Model.endDispNum"
        (prevHandler)="eventBackHandler()" (nextHandler)="eventNextHandler()">
      </app-pager>
    </div>

    <wj-flex-grid #dtg_CandidateGoodsProofList id="dtg_CandidateGoodsProofList" [headersVisibility]="'Column'"
      [allowSorting]="false" [itemsSource]="kymw4200Model.candidateGoodsProofList" [allowDragging]="'None'"
      [selectionMode]="'Row'" (click)="eventCandidateGoodsListHandler($event)" (selectionChanged)="setColorPattern()"
      [isReadOnly]="true" [tabindex]="0">

      <wj-flex-grid-column [minWidth]="5" [width]="40" [binding]="'TargetFlg'" [header]="' '">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div [style.background-color]="this.kymw4200Model.colorList[cell.row.index]">
            <input type="checkbox" id="TargetFlg_{{cell.row.index}}" [(ngModel)]="cell.item.TargetFlg" [tabindex]="-1"
              (mouseup)="$event.stopPropagation()" />
          </div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="140" [binding]="'ClassCode'" [header]="'部門'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div [style.background-color]="this.kymw4200Model.colorList[cell.row.index]">
            {{ cell.item.ClassCode }}
          </div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="240" [binding]="'SmallClassCode'" [header]="'小分類'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div [style.background-color]="this.kymw4200Model.colorList[cell.row.index]">
            {{ cell.item.SmallClassCode }}
          </div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="120" [binding]="'PCode'" [header]="'Ｐコード'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div [style.background-color]="this.kymw4200Model.colorList[cell.row.index]">
            {{ cell.item.PCode }}
          </div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="120" [binding]="'ItemCode'" [header]="'アイテムコード'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div [style.background-color]="this.kymw4200Model.colorList[cell.row.index]">
            {{ cell.item.ItemCode }}
          </div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="471" [binding]="'GuideGoodsName'" [header]="'商品名'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div [style.background-color]="this.kymw4200Model.colorList[cell.row.index]">
            {{ cell.item.GuideGoodsName }}
          </div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="471" [binding]="'GuideStandardName'" [header]="'規格名'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div [style.background-color]="this.kymw4200Model.colorList[cell.row.index]">
            {{ cell.item.GuideStandardName }}
          </div>
        </ng-template>
      </wj-flex-grid-column>
    </wj-flex-grid>
  </div>
</div>

<footer class="footer-buttons">
  <button id="btn_Out" class="btn-primary" #btn_Out [disabled]="!kymw4200Model.btnOutputEnabled"
    forcedEnabledMode="true" (click)='eventOutput_CLICKHandler()' [tabindex]="0">出力</button>
</footer>